<template>
  <div class="answer-message-row">
    <div class="answer-message-avatar">
      <img alt="SUPERDOC" class="answer-avatar-icon" src="@public/assets/images/ic_superdoc_ava.svg" />
    </div>
    <div class="answer-message-content">
      <p class="answer-message-name">SUPERDOC</p>
      <div class="answer-message-bubble message-item">
        <div class="markdown-content answer-markdown" v-html="markdownRenderer(content)"></div>
      </div>
      <div class="answer-message-actions">
        <button type="button" class="answer-action-btn" aria-label="Sao chep" @click="$emit('copy', content)">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
          </svg>
          Sao chép
        </button>
        <button type="button" class="answer-action-btn" aria-label="In" @click="$emit('print', content)">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
            <rect x="6" y="14" width="12" height="8" rx="1"></rect>
          </svg>
          In
        </button>
        <button type="button" class="answer-action-btn" aria-label="Xuat PDF" @click="$emit('pdf', content)">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
            <path d="M12 18v-6"></path>
            <path d="m9 15 3 3 3-3"></path>
          </svg>
          PDF
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperDocAnswerMessage',
  props: {
    content: {
      type: String,
      default: ''
    },
    markdownRenderer: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.answer-message-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 8px;
}

.answer-message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbeafe;
  background: #eff6ff;
}

.answer-avatar-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.answer-message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  max-width: 90%;
}

.answer-message-name {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 500;
  margin-left: 4px;
  margin-bottom: 0;
  text-transform: uppercase;
}

.answer-message-bubble {
  width: 100%;
  border: 1px solid #f1f5f9;
  background: #fff;
  color: #334155;
  border-radius: 16px;
  border-top-left-radius: 0;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  word-break: normal;
  overflow-wrap: break-word;
  line-break: auto;
  hyphens: none;
  overflow-x: auto;
}

.answer-markdown {
  font-size: 13px;
  line-height: 1.6;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  line-break: auto;
  hyphens: none;
}

.answer-markdown :deep(*) {
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  line-break: auto;
  hyphens: none;
}

.answer-markdown :deep(p) {
  margin: 0 0 8px;
}

.answer-markdown :deep(p:last-child) {
  margin-bottom: 0;
}

.answer-markdown :deep(a) {
  color: #2563eb;
  text-decoration: underline;
}

.answer-markdown :deep(ul),
.answer-markdown :deep(ol) {
  margin: 0 0 8px;
  padding-left: 18px;
}

.answer-message-bubble .answer-markdown :deep(table) {
  width: 100%;
  min-width: 480px;
  border-collapse: collapse !important;
  margin: 8px 0;
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  overflow: hidden !important;
  font-size: 12px;
  background: #ffffff !important;
}

.answer-message-bubble .answer-markdown :deep(th),
.answer-message-bubble .answer-markdown :deep(td) {
  border: 1px solid #e2e8f0 !important;
  padding: 8px 10px !important;
  text-align: left !important;
  vertical-align: top !important;
  line-height: 1.5 !important;
}

.answer-message-bubble .answer-markdown :deep(th) {
  background: #f8fafc !important;
  color: #1e293b !important;
  font-weight: 600 !important;
}

.answer-message-bubble .answer-markdown :deep(tr:nth-child(even) td) {
  background: #fcfdff !important;
}

.answer-message-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
}

.answer-action-btn {
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 11px;
}

.answer-action-btn:hover {
  color: #2563eb;
  background: #eff6ff;
}
</style>
